<template>
    <div>

        <AlertDismiss ref="alertDismiss"></AlertDismiss>

        <b-pagination v-model="filter.page" :total-rows="rows" :per-page="filter.pageSize"
                      aria-controls="table-list-statements" class="m-2" pills>
        </b-pagination>

    </div>
</template>
<script>
import { EventNames, InitPageSize } from '@/plugins/enums/index.js'
import { mapActions } from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'

export default {
    name: 'PaginationStatements',

    data() {
        return {
            filter: {
                page: 1,
                pageSize: InitPageSize.PepStatementsPageSize,
            },

            rows: 0
        }
    },

    components: {
        AlertDismiss
    },

    async mounted() {
        await this.getCountStatements();

        //emitimos el evento para inicializar los valores de la tabla usuarios
        await this.paginationFilterStatements();
    },

    methods: {
        ...mapActions(["countPepStatements"]),

        paginationFilterStatements() {
            this.$eventBus.$emit(EventNames.PaginationFilterPepStatements, this.filter);
        },

        async getCountStatements() {
            const result = await this.countPepStatements();
            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }

            this.rows = result.data;
        }

    },

    watch: {
        //cada ves que se haga un click al paginador entonces emite el evento
        async "filter.page"() {
            this.paginationFilterStatements();
        },
    },

}
</script>